// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn,.v-select,.v-text-field{margin:0 .5em;font-size:14px}#filters-card-style{padding-top:1em}.p-filters-wrapper{margin-bottom:.5em}", ""]);
// Exports
module.exports = exports;
